document.addEventListener('keydown', (e) => {
    if (e.code === "Tab"){
        var htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.className = "no-mouse-user no-touchevents";
    }
});
document.addEventListener('mousedown', (e) => {
    var htmlElement = document.getElementsByTagName('html')[0];
    htmlElement.className = "mouse-user no-touchevents";
});